import { ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
type CtaButtonProps = {
  /** Explicit checkout URL, or an in-page anchor for scroll CTAs. */
  href: string;
  label: string;
  size?: 'md' | 'lg' | 'xl';
  /**
   * `primary` — the dominant green buy button.
   * `secondary` — a clear but quieter buy button (outlined).
   * `scroll` — in-page navigation, never a checkout.
   */
  variant?: 'primary' | 'secondary' | 'scroll';
};
const SIZING = {
  md: 'text-xs px-4 py-3.5 sm:text-sm sm:px-6 sm:py-4',
  lg: 'text-sm px-5 py-4 sm:text-base sm:px-7 sm:py-5',
  xl: 'text-sm px-5 py-5 sm:text-lg sm:px-8 sm:py-6'
};
const PALETTE = {
  primary: 'bg-verde text-white shadow-[0_14px_36px_-12px_rgba(22,163,74,0.7)] hover:bg-verde-light focus-visible:outline-verde-light',
  secondary: 'border-2 border-aluminio/40 bg-transparent text-crudo hover:border-crudo/70 hover:bg-crudo/5 focus-visible:outline-aluminio',
  scroll: 'border-2 border-electrico bg-electrico/10 text-crudo hover:bg-electrico/20 focus-visible:outline-electrico-light'
};
export function CtaButton({
  href,
  label,
  size = 'md',
  variant = 'primary'
}: CtaButtonProps) {
  const Icon = variant === 'scroll' ? ArrowDownIcon : ArrowRightIcon;
  return <a href={href} className={`group inline-flex w-full items-center justify-center gap-2 rounded-xl text-center font-display font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,border-color] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${PALETTE[variant]} ${SIZING[size]}`} data-id="element-30" data-mp="3ex2plsp2mb3c">
      <span data-id="element-31" data-mp="1jhjiqhkhpl9">{label}</span>
      <Icon className={`h-4 w-4 shrink-0 transition-transform duration-150 ease-out ${variant === 'scroll' ? 'group-hover:translate-y-0.5' : 'group-hover:translate-x-1'}`} aria-hidden="true" data-id="element-32" data-mp="1laeh8itildf" />
    </a>;
}